"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _getEnvVar = require("./getEnvVar");
Object.keys(_getEnvVar).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _getEnvVar[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _getEnvVar[key];
    }
  });
});